// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/components/student-notes.scss
// module id = 884
// module chunks = 0